import { useDataValue } from 'Simple/Data.js'
import { formatTzDate } from 'Data/format.js'

export default function useDataConfiguration(props) {
  let date = useDataValue({
    context: 'tab',
    path: 'selected.date',
    viewPath: props.viewPath,
  })
  let time_zone_id = useDataValue({
    context: 'tab',
    path: 'selected.time_zone_id',
    viewPath: props.viewPath,
  })
  let location_id = useDataValue({
    context: 'tab',
    path: 'selected.location_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      date: formatTzDate(date, 'yyyy-MM-dd', time_zone_id),
      location_id,
    },
    pause: !date || !time_zone_id || !location_id,
    requestPolicy: 'cache-and-network',
  }
}
